export enum EnumInterestPlan {
  BASIC_PLAN = "Plano Essencial",
}
